import { Link } from "gatsby"
import PropTypes from "prop-types"
import React, { useState } from "react"
import { Menu, Icon, Button, Drawer } from "antd"
import { possibleCatagories } from "../global/contants"
import { navigate } from "@reach/router"

const { SubMenu } = Menu

const ResponsiveMenu = props => (
  <Menu mode="inline" defaultSelectedKeys={[props.currentCatag]}>
    <Menu.Item
      onClick={() =>
        navigate("https://gutenberghub.com/category/gutenberg-resources/")
      }
    >
      Browse Tutorials
    </Menu.Item>

    <Menu.Item onClick={() => navigate("https://gutenberghub.com/blocks/")}>
      Visit Block Directory
    </Menu.Item>
    <SubMenu
      title={
        <span className="submenu-title-wrapper">
          <span className="cwp-menu-drop">Gutenberg Template Library</span>
          <Icon type="down" />
        </span>
      }
    >
      {possibleCatagories.map((v, i) => (
        <Menu.Item key={v.toLowerCase()}>
          <Link to={`/section/${v.toLowerCase()}`}>{v}</Link>
        </Menu.Item>
      ))}
    </SubMenu>
  </Menu>
)
const PageHeader = props => {
  const [responsiveDrawer, setResponsiveDrawer] = useState(false)

  return (
    <header className="cwp-page-header">
      <div className="logo">
        <Link to="/">
          <img
            alt="logo"
            src="https://gutenberghub.com/wp-content/uploads/2018/01/ghub-site-logo-1.png"
          />
        </Link>
      </div>
      <div className="cwp-menu">
        <Menu
          theme="light"
          mode="horizontal"
          defaultSelectedKeys={[props.currentCatag]}
          style={{ lineHeight: "64px" }}
        >
          <Menu.Item
            onClick={() =>
              navigate("https://gutenberghub.com/category/gutenberg-resources/")
            }
          >
            Browse Tutorials
          </Menu.Item>

          <Menu.Item
            onClick={() => navigate("https://gutenberghub.com/blocks/")}
          >
            Visit Block Directory
          </Menu.Item>
          <SubMenu
            title={
              <span className="submenu-title-wrapper">
                <span className="cwp-menu-drop">
                  Gutenberg Template Library
                </span>
                <Icon type="down" />
              </span>
            }
          >
            {possibleCatagories.map((v, i) => (
              <Menu.Item key={v.toLowerCase()}>
                <Link to={`/section/${v.toLowerCase()}`}>{v}</Link>
              </Menu.Item>
            ))}
          </SubMenu>
        </Menu>
      </div>

      <div className="cwp-responsive-toggle">
        <Button onClick={() => setResponsiveDrawer(true)}>
          <Icon type="menu" />
        </Button>
      </div>
      <Drawer
        title="Menu"
        placement="right"
        className="cwp-main-drawer"
        closable={true}
        onClose={() => setResponsiveDrawer(false)}
        visible={responsiveDrawer}
      >
        <ResponsiveMenu currentCatag={props.currentCatag} />
      </Drawer>
    </header>
  )
}

PageHeader.propTypes = {
  siteTitle: PropTypes.string,
}

PageHeader.defaultProps = {
  siteTitle: ``,
}

export default PageHeader
